import api from "@/api/index";
import { User } from "@/api/models/User";

export const state = {
  currentUser: new User(),
  rememberMe: api.rememberToken,
  userToken: api.userToken,
  users: [],
  fileGroups: [],

  getMeRequest: {
    requesting: false
  }
};

export const getters = {
  loggedIn(state) {
    return state.currentUser.id >= 0;
  }
};

export const actions = {
  async logIn({ dispatch, getters, commit }, req) {
    if (getters.loggedIn) {
      const validateRes = await dispatch("validate");
      return validateRes;
    }

    const res = await api.logIn(req);
    commit("SET_USER_TOKEN", res.data.access_token);

    const user = await dispatch("getMe");

    return user;
  },

  async logInByToken({ dispatch, commit }, token) {
    commit("REMEMBER_ME", true);
    commit("SET_USER_TOKEN", token);

    try {
      const user = await dispatch("getMe");

      return user;
    } catch (error) {
      commit("SET_USER_TOKEN", undefined);
      throw error;
    }
  },

  async logOut({ commit }) {
    const res = await api.logOut();
    commit("SET_CURRENT_USER", {});
    commit("SET_USER_TOKEN", null);
    return res;
  },

  async getMe({ state, commit }) {
    commit("GET_CURRENT_USER_REQUEST", true);

    try {
      const res = await api.getMe();
      commit("SET_CURRENT_USER", res.data);
      return state.currentUser;
    } finally {
      commit("GET_CURRENT_USER_REQUEST", false);
    }
  },

  async getUsers({ commit }) {
    const res = await api.getUsers();
    commit("SET_USERS", res.data.data);
    return res;
  },

  async getFileGroups({ commit }) {
    const res = await api.getFileGroups();
    commit("SET_FILE_GROUPS", res.data.data);
    return res;
  },

  async refreshToken({ commit, state }) {
    if (!state.userToken) return null;

    try {
      const tokenRes = await api.validateToken();
      commit("SET_USER_TOKEN", tokenRes.data.access_token);
    } catch (error) {
      commit("SET_CURRENT_USER", null);
      commit("SET_USER_TOKEN", null);
      return null;
    }
  },

  async validate({ state, commit }) {
    if (!state.userToken) return false;

    try {
      await api.validateToken();
    } catch (error) {
      commit("SET_USER_TOKEN", undefined);
    }
  }
};

export const mutations = {
  SET_CURRENT_USER(state, user) {
    state.currentUser = new User(user);

    window.OneSignal.push(() => {
      window.OneSignal.sendTags({
        uuid: state.currentUser.uuid
      });
    });
  },

  UPDATE_AVATAR(state, avatar) {
    state.currentUser.avatar = avatar;
  },

  SET_USERS(state, data) {
    state.users = data;
  },

  SET_FILE_GROUPS(state, data) {
    state.fileGroups = data;
  },

  GET_CURRENT_USER_REQUEST(state, requesting) {
    state.getMeRequest.requesting = requesting;
  },

  REMEMBER_ME(state, remember) {
    state.rememberMe = remember;
    api.rememberToken = remember;
  },

  SET_USER_TOKEN(state, token) {
    state.userToken = token;
    api.userToken = token;
  }
};
